export class BboxValueObject {
  xmin!: number;
  ymin!: number;
  xmax!: number;
  ymax!: number;
  srid!: number;

  constructor(init: { xmin: number; ymin: number; xmax: number; ymax: number; srid: number }) {
    Object.assign(this, init);
  }
}
